import React, { useEffect, useState } from 'react'
import Course from './Course'
import AboutMe from './AboutMe'
import Banner from './Banner'
import VideoModal from './VideoModal'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { getHomaData } from '../../Redux/ActionCreater'
import { Helmet } from 'react-helmet-async'
function HomePage() {
  const [aboutme,setAboutme]=useState();
  const [banner,setBanner]=useState();
  const [course,setCourse]=useState();
  const [res,setRes]=useState();
  const [loading,setLoading]=useState(true);
  const [video,setVideo]=useState(false);
  const [youtube_id,setYoutubeId]=useState("");
  const dispatch = useDispatch();
  const { homepageData,isLoading} = useSelector(
    (state) => ({
      homepageData: state.dataReducer,
      isLoading: state.dataReducer.isLoading,
    }),
    shallowEqual
  );


  useEffect(() => {
    // $('.lazy').Lazy();
    fetchData()
  }, [])
  
  
 useEffect(() => {
   
  setAboutme(homepageData.homepageData.aboutme);
  setBanner(homepageData.homepageData.banner);
  setCourse(homepageData.homepageData.course);
  setYoutubeId(homepageData.homepageData.youtube_id);
  setRes(homepageData.homepageData.home_course);
  homepageData.homepageData.home_course&&setLoading(isLoading);
 }, [homepageData])
 
  const fetchData = () => {
  
    let header={
      headers:{
      "X-Auth-Token":"12345"
    }};
    dispatch(getHomaData(header));
  };
  
  const closeModal =()=>{
    setVideo(false)
  };
  const openModal=(e)=>{
    e.preventDefault();
    setVideo(true)
  }
  return (
     <>
     <Helmet>
          <title>{`CNC Machine :: Home`}</title>
          <meta property="og:title" content="CNC Machine :: Home"/>

          {/* <meta name="description" content={res?.meta_description} />
          <meta name="keywords" content={res?.meta_keywords} />
          <meta name="title" content={res?.meta_title} /> */}
        </Helmet>
     {loading===true?<div className="loader-container">
        <div className="spinner"></div>
      </div>:
<>

   <Banner data={banner}/>
   <AboutMe data={aboutme}/>
   <Course data={course}  openModal={openModal} res={res}/>
      {video&&<VideoModal youtube_id={youtube_id} closeModal={closeModal}/>}
      </>
      }
    </>
  )
}

export default HomePage